"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersection = exports.styleMapToAttribs = exports.isEmptyObject = exports.styleToString = exports.decodeBreakingEntities = exports.encodeBreakingEntities = exports.parseStyleCssText = void 0;
const camelize = (str) => {
    return str.replace(/(?:^|[-])(\w)/g, (a, c) => {
        c = a.substring(0, 1) === '-' ? c.toUpperCase() : c;
        return c ? c : '';
    });
};
const parseStyleCssText = (value) => {
    const output = {};
    if (!value) {
        return output;
    }
    const style = value.split(';');
    for (const s of style) {
        const rule = s.trim();
        if (rule) {
            const ruleParts = rule.split(':');
            const key = camelize(ruleParts[0].trim());
            output[key] = ruleParts[1].trim();
        }
    }
    return output;
};
exports.parseStyleCssText = parseStyleCssText;
const encodeBreakingEntities = (str) => {
    const swapChar = (charToSwap) => {
        // that swaps characters to HTML entities
        switch (charToSwap) {
            case '&':
                return '&amp;';
            case '<':
                return '&lt;';
            case '>':
                return '&gt;';
            default:
                return charToSwap;
        }
    };
    str = str.replace(/[&<>]/g, (match) => {
        return swapChar(match);
    });
    return str;
};
exports.encodeBreakingEntities = encodeBreakingEntities;
const decodeBreakingEntities = (str) => {
    return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
};
exports.decodeBreakingEntities = decodeBreakingEntities;
const styleToString = (style) => {
    return Object.keys(style).reduce((acc, key) => acc +
        key
            .split(/(?=[A-Z])/)
            .join('-')
            .toLowerCase() +
        ':' +
        style[key] +
        ';', '');
};
exports.styleToString = styleToString;
const isEmptyObject = (obj) => obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
exports.isEmptyObject = isEmptyObject;
const styleMapToAttribs = ({ elementStyleMap, node, }) => {
    let attribs = {};
    const styleAttrs = {};
    Object.keys(elementStyleMap).forEach((slateKey) => {
        const cssProperty = elementStyleMap[slateKey];
        const cssValue = node[slateKey];
        if (cssValue) {
            styleAttrs[cssProperty] = cssValue;
        }
    });
    if (!(0, exports.isEmptyObject)(styleAttrs)) {
        attribs = Object.assign(Object.assign({}, attribs), { style: (0, exports.styleToString)(styleAttrs) });
    }
    return (0, exports.isEmptyObject)(attribs) ? {} : attribs;
};
exports.styleMapToAttribs = styleMapToAttribs;
const intersection = (o1, o2) => {
    return Object.keys(o1)
        .concat(Object.keys(o2))
        .sort()
        .reduce((r, a, i, aa) => {
        if (i && aa[i - 1] === a) {
            r.push(a);
        }
        return r;
    }, []);
};
exports.intersection = intersection;
